import Constant from 'BASE/common/lotteryConstant';

const numberPlugin = {
    install: function (Vue, options) {
        Vue.prototype.$number = {

            /** 修正浮點數溢位 */
            fixFloatingNumber(value) {
                return parseFloat(value.toFixed(Constant.DecimalPrecision));
            },

            /** 加上千分位符號 */
            currency(value) {
                return value.toString().replace(/^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/, function (all, pre, groupOf3Digital) {
                    return pre + groupOf3Digital.replace(/\d{3}/g, ',$&');
                });
            },

            
        };
    }
};

export default numberPlugin;